import ObjectIterator from "../utils/object_iterator";

export default class InputValidator {

	static validate(fields, actionName) {
		let errors = Array.isArray(fields)
			? this.validateArrayOfFields(fields, actionName)
			: this.validateObjectOfFields(fields, actionName);

		return errors;
	}

	static validateArrayOfFields(fields, actionName) {
		let errors = {};

		fields.forEach((field) => {
			const fieldId = field.id;
			let validations = this.getValidationsForAction(field, actionName);
			let inputErrors = this.validateInput(fieldId, field, validations, errors);

			if (inputErrors) {
				errors[inputErrors.name] = inputErrors.message;
			}
		});

		return errors;
	}

	static validateObjectOfFields(fields, actionName) {
		let errors = {};

		for (let [fieldName, field] of ObjectIterator.iterate(fields)) {
			let validations = this.getValidationsForAction(field, actionName);
			let inputErrors = this.validateInput(fieldName, field, validations, errors);

			if (inputErrors) {
				errors[inputErrors.name] = inputErrors.message;
			}
		}

		return errors;
	}

	static getValidationsForAction(input, actionName) {
		if(!actionName)
			return input.validations;

		return input.validations.filter(validation => validation.formActionName === actionName);
	}

	static validateInput(inputName, input, validations) {
		if (!validations.length) return null;

		if (this.validateInputRequired(input, validations)) {
			return {
				name: inputName,
				message: [Realize.i18n.t('form.validations.required')] // por que tem que ser um array?
			}
		}

		return null;
	}

	static validateInputRequired(input, validations) {
		let value = this.checkValue(input.value);

		return validations.reduce((previousValidationState, currentValidation) => {
			return previousValidationState || (currentValidation.required && (value === undefined || value === null || value === '' || (typeof value === "object" && !Object.keys(value).length)));
		}, false);
	}

	static checkValue(value) {
		if(typeof value === "string") {
			return value.trim()
		}else if(typeof value === "object") {
			if(value && value[0]) {
				return value;
			}
		}else{
			return value;
		}
	}

}
